import screenfull from "screenfull";
import { getRootElement } from "./dom";

export const checkIfPortrait = () => {
  return window.matchMedia("screen and (orientation:portrait)").matches;
};

export const enterFullScreen = () => {
  const docEl = getRootElement();
  if (screenfull.isEnabled) {
    screenfull.request(docEl);
  }
};

export const exitFullScreen = () => {
  if (screenfull.isEnabled) {
    screenfull.exit();
  }
};

export default {
  checkIfPortrait,
  enterFullScreen,
  exitFullScreen,
};
